import { dimension } from './dimensions';

/*
  Open question: Should we define every dimension in this file?
*/

export const businessId = dimension('Business Id', 'BUSINESS_ID');
export const businessName = dimension('Business Name', 'BUSINESS_NAME');
export const experienceName = dimension('Experience Name', 'EXPERIENCE_NAME');
